module.exports = __webpack_public_path__ + "img/error4.562df229.png";